import React from 'react';
import './App.css';
import {ThemeProvider} from "./components/styling/ThemeProvider";
import {RouterProvider} from "react-router-dom";
import {router} from "./components/Router";

function App() {
  return (
    <ThemeProvider>
      <RouterProvider router={router}/>
    </ThemeProvider>
  );
}

export default App;
